import React from 'react'
import company from '../img/aboutus/The-Company.png'
import team from '../img/aboutus/team.png';
import MasterPlanning from '../img/aboutus/Master-Planning.png';
import Architecture from '../img/aboutus/Architecture.png';
import InteriorDesign from '../img/aboutus/Interior-Design.png';
import AlliedServices from '../img/aboutus/Allied-Services.png';

const About = () => {
	return (
		<div>
			<section className="section p-t-100 p-b-65" id="about-banner">
				<div className="container">
					<div className="page-heading">
						<h4 className="about_t">About Us</h4>
					</div>
				</div>
			</section>
			<section className="company">
				<div className="container">
					<div className="row">
						<div className="col-lg-6">
							<div className="con-d">
								<h2>The Company</h2>
								<p className="t-s-j">
									We are a young, innovative design studio committed to creating
									environmentally responsible buildings that embody the highest
									standards of quality architecture. Our designs seamlessly
									blend local architectural character with post-modern
									simplicity, resulting in distinctive and timeless spaces.
									Backed by a passionate and dedicated team, we consistently
									meet client requirements while crafting unique identities for
									each project.
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<img src={company} className="img-12" alt="company`img" />
						</div>
					</div>
				</div>
			</section>
			<section className="company">
				<div className="container">
					<div className="row">
						<div className="col-lg-6">
							<div className="con-d">
								<h2>The Team</h2>
								<p className="t-s-j">
									Our team consists of experienced professionals, led by
									industry veterans with over 25 years of expertise in
									architectural design. We are committed to making each project
									unique, delivering utmost satisfaction to end users. By
									carefully managing project assignments, we ensure unwavering
									quality and a user-centric approach. United by strong
									professional ethics, our team operates as a cohesive family,
									dedicated to excellence in every endeavor.
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<img src={team} class="img-12" alt="team`s img" />
						</div>
					</div>
				</div>
			</section>
			<section className="p-t-60 p-b-60" id="our_ser">
				<div className="container">
					<div className="section-title">
						<h2 className="title-1">Our Services</h2>
					</div>
					<div className="row no-gutters">
						<div className="col-md-6 col-lg-3" id="b-o">
							<article className="media media-service" id="our_ser_icon">
								<figure className="media__img mbt-20" id="mb-0">
									<img src={MasterPlanning} alt="architecture" />
								</figure>
								<div className="media__title">
									<h3 className="title">
										<a href="#">Master Planning</a>
									</h3>
									<span className="number">01</span>
								</div>
								<p className="media__text">
									Master Planning is a knowledge based solution based on social
									and environmental requirement, without comprising on
									commercial viability.
								</p>
							</article>
						</div>
						<div className="col-md-6 col-lg-3" id="b-o">
							<article className="media media-service" id="our_ser_icon">
								<figure className="media__img mbt-20" id="mb-0">
									<img src={Architecture} alt="Interior" />
								</figure>
								<div className="media__title">
									<h3 className="title">
										<a href="#">Architecture</a>
									</h3>
									<span className="number">02</span>
								</div>
								<p className="media__text">
									Architecture is again a knowledge based solution based on our
									design philosophy to give the end user a better way of living.
								</p>
							</article>
						</div>
						<div className="col-md-6 col-lg-3" id="b-o">
							<article className="media media-service" id="our_ser_icon">
								<figure className="media__img mbt-20" id="mb-0">
									<img src={InteriorDesign} alt="planning" />
								</figure>
								<div className="media__title">
									<h3 className="title">
										<a href="#">Interior Design</a>
									</h3>
									<span className="number">03</span>
								</div>
								<p className="media__text">
									We see Interior design as an art and science for giving the
									end user the more aesthetically pleasing environment.
								</p>
							</article>
						</div>
						<div className="col-md-6 col-lg-3" id="b-o">
							<article className="media media-service" id="our_ser_icon">
								<figure className="media__img mbt-20" id="mb-0">
									<img src={AlliedServices} alt="planning" />
								</figure>
								<div className="media__title">
									<h3 className="title">
										<a href="#">Allied Services</a>
									</h3>
									<span className="number">04</span>
								</div>
								<p className="media__text">
									Allied services for Master Planning, Architecture and Interior
									design are provided to us by professionals who are the best in
									their subjects.
								</p>
							</article>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default About